import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import '../Ventas/FT.css';

import { useParams } from 'react-router-dom';
import * as moment from 'moment'



const ImpresionPrestamo = () => {
    let { Pedido } = useParams();
    const [ListadoLinea, SetListadoLinea] = useState([]);




    useEffect(() => {
        obtenerDatos(Pedido)
        obtenerDatosLineas();
        
    }, [])

   
    const obtenerDatos = async (e) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoCotizacionID/"+ parseInt(e));
        if (response.ok) {
            let data = await response.json();
          
           
        }
    }

    const obtenerDatosLineas = async () => {
        let response = await fetch(Api + "Transporte/ListaPrestamosLineas/" + Pedido);
        if (response.ok) {
            let data = await response.json()
            SetListadoLinea(data)
        }
    }

   // function currencyFormatter({ currency, value }) {
    const currencyFormatter=({ currency, value }) =>{
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 2,
            currency
        })
        return formatter.format(value)
    }

    const Imprimir = () => {
        //SetVerImprimir(true)
        window.print();
     
    }
   
    

    return (
        <>
           
              

            <div class="letra" >

              
                
                <div class="printArea">
                    <div class="page">

                     
                        <html lang="en">
                        
                                    <body>

                                        <div class="container">
                                    <div class="header">
                                      
                                       <b> Transporte Nelson Sanchez Inc.</b>
                                        <b> Prestamos Personal</b>
                                        <br/>
                                        <p> Acuerdo de pago entre la <b>Sra. Yoanna E. Alcala</b> y el<b> Sr. Nelson Sanchez.</b>
                                        Se acuerda pagos de $400 pesos, a pagos semanales, por el monto total de $6,000 pesos.</p>
                                      <p>  A continuación un desglose de los pagos que se realiza en efectivo con pago presencial al Sr. Nelson Sánchez.</p>

                                     
                                      
                                            </div>

                                        
                                              
                                    <div class="bill-info">
                                        <table className="tab-border">
                                            <tr>
                                                <th>Semanas</th>
                                                <th>Dias</th>
                                                <th>Fecha</th>
                                                <th>Pago</th>
                                                <th>X</th>
                                                <th>Restante</th>
                                            </tr>
                                            {ListadoLinea.map(x => (<tr>
                                                <td>{x.cuotaNum }</td>
                                                <td>Sabado</td>
                                                <td>{ x.descripcionFecha}</td>
                                                <td>{x.montoCuota}</td>
                                                <td>{x.pago}</td>
                                                <td>{x.restante}</td>
                                            </tr>))
                                            }
                                        </table>

                                    </div>
                                    <br></br>
                                    <br></br> 
                                    <div class="bill-info">
                                       

                                        <div style={{
                                            //borderTop: '2px solid',
                                            width: '30%',
                                            textAlign: 'center'} }>
                                            <div style={{ width: '200px', height: '90px', borderBottom: '2px solid' }}></div>
                                            Recibido Por


                                        </div>
                                     
                                        <div style={{
                                           // borderTop: '2px solid',
                                            width: '30%', height: '100px',
                                            textAlign: 'center'
                                        }}>
                                            <div style={{ width: '200px', height: '90px', borderBottom: '2px solid' }}></div>
                                       Recibido Por


                                        </div>
                                    </div>


                                        </div>

                                    </body>
                                </html>

                       

                    </div>

                </div>
            </div>
       
        </>
        )

}
export default ImpresionPrestamo;